import React from "react";
import PropTypes from "prop-types";

function RadioButtons({
	children,
	name,
	values,
	error,
	register,
	required,
	...rest
}) {
	return (
		<div className="field">
			{children && <label className="label">{children}</label>}
			<div className="control">
				{values.map(button => {
					return (
						<label className="radio" key={button.label} htmlFor={button.value}>
							<input
								{...rest}
								name={name}
								id={button.value}
								type="radio"
								ref={register({ required })}
								value={button.value}
								defaultChecked={button.checked}
							/>{" "}
							{button.label}
						</label>
					);
				})}
			</div>
			{error && <p className="help is-primary">{error.message}</p>}
		</div>
	);
}

RadioButtons.defaultProps = {
	error: null,
	required: false,
	children: null
};

RadioButtons.propTypes = {
	children: PropTypes.string,
	error: PropTypes.shape({}),
	name: PropTypes.string.isRequired,
	register: PropTypes.func.isRequired,
	required: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.shape({ value: PropTypes.bool, message: PropTypes.string })
	]),
	values: PropTypes.arrayOf(
		PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
	).isRequired
};

export default RadioButtons;